<div class="container ktbl-container-border ktbl-container-size">
  <span *ngIf="isEdit == true">
    <h3 mat-dialog-title>Quelle bearbeiten</h3>
  </span>

  <span *ngIf="isEdit == false">
    <h3 mat-dialog-title>Quelle definieren</h3>
  </span>

  <mat-dialog-content>
    <div class="ktbl-grid-container-columns-2">
      <mat-form-field appearance="fill" class="ktbl-input-box">
        <mat-label>Quelle</mat-label>
        <mat-select required disableRipple [formControl]="quelleFormControl" [errorStateMatcher]="matcher"
          panelClass="ktbl-large-select-panel">
          <mat-option [value]="1">Stall</mat-option>
          <mat-option [value]="2">Fläche</mat-option>
          <mat-option [value]="3">Sonstige</mat-option>
        </mat-select>

        <mat-error *ngIf="quelleFormControl.invalid">
          Es wird eine Quelle benötigt
        </mat-error>
      </mat-form-field>

      <mat-form-field class="ktbl-input-box" appearance="fill">
        <mat-label>Bezeichnung </mat-label>

        <input matInput required [errorStateMatcher]="matcher" [formControl]="bezeichnungFormControl" />
        <mat-error *ngIf="bezeichnungFormControl.invalid">
          Es wird eine Bezeichnung für die Quelle benötigt
        </mat-error>
      </mat-form-field>
    </div>
    <div class="ktbl-spacer-top-bottom"></div>
    <div class="ktbl-grid-container-columns-3">


      <!--------------------------------------------------------------------------------------------------->
      <ng-container *ngIf="quelleFormControl.value === 1">
        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Tierart</mat-label>
          <mat-select required disableRipple [formControl]="stallTierartFormControl" [errorStateMatcher]="matcher"
            (selectionChange)="onSelectStallTierart()" panelClass="ktbl-large-select-panel">
            <mat-option *ngFor="let entry of localService.tierartList.value" [value]="entry.idTierart">
              {{ entry.tierart }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="stallTierartFormControl.invalid">
            Es wird eine Tierart benötigt
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Tierkategorie</mat-label>
          <mat-select required disableRipple [formControl]="stallTierkategorieFormControl" [errorStateMatcher]="matcher"
            (selectionChange)="onSelectStallTierkategorie()" panelClass="ktbl-large-select-panel">
            <mat-option *ngFor="let entry of selectedTierkategorienList" [value]="entry.idTierkategorie">
              {{ entry.tierkategorieGv }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="stallTierkategorieFormControl.invalid">
            Es wird eine Tierkategorie benötigt
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box ">
          <mat-label>Haltungsverfahren</mat-label>
          <mat-select required disableRipple [formControl]="stallHaltungsverfahrenFormControl"
            [errorStateMatcher]="matcher" (selectionChange)="onSelectStallTkHvGeruchsemission()"
            panelClass="ktbl-large-select-panel">
            <mat-option *ngFor="
                  let entry of selectedTkHvGeruchsemissionList
                " [value]="entry.idTkHvGeruchsemissionZuord">
              {{ entry.haltungsverfahrenFaktor }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="stallHaltungsverfahrenFormControl.invalid">
            Es wird ein Haltungsverfahren benötigt.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Emissionsminderungsmaßnahme</mat-label>
          <mat-select required disableRipple [formControl]="stallMinderungsmassnahmeFormControl"
            [errorStateMatcher]="matcher" (selectionChange)="onSelectStallMinderungsmassnahmeTier()"
            panelClass="ktbl-large-select-panel">
            <mat-option *ngFor="
                  let entry of selectedMinderungsmassnahmeTierkategorieList
                " [value]="entry.idMmTierartenZuord">
              {{
              entry.minderungsmassnahmeWirkungsgrad
              }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="stallMinderungsmassnahmeFormControl.invalid">
            Es wird eine Emissionsminderungsmaßnahme benötigt.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Anzahl Tiere</mat-label>
          <input matInput required [errorStateMatcher]="matcher" [formControl]="stallAnzahlTiereFormControl" />
          <mat-error
            *ngIf="stallAnzahlTiereFormControl.invalid">
            {{ formControlGanzZahlLaeng5Ohne0NumberWarning }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Wirkungsgrad in %
            <i class="fas fa-info-circle ktbl-icon-info-select"
              matTooltip="Entsperrt wenn bei Emissionsminderungsmaßnahme 'Sonstige Maßnahme' ausgewählt ist."
              matTooltipClass="tooltip-format" [matTooltipPosition]="tooltipPosition.value">
            </i>
          </mat-label>

          <input matInput required [errorStateMatcher]="matcher" [formControl]="stallWirkungsgradFormControl" />
          <mat-error
            *ngIf="stallWirkungsgradFormControl.invalid">
            {{ formControlGanzZahlLaeng2OderKomma1NumberWarning }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Tierartspezifischer Gewichtungsfaktor f
            <i class="fas fa-info-circle ktbl-icon-info-select"
              matTooltip="Faktor (zwischen 0,5 und 1,5) nach Anhang 7 TA Luft, mit dem die unterschiedliche Belästigungswirkung der Geruchsemissionen verschiedener Tierarten bei der Abstandsbemessung berücksichtigt wird."
              matTooltipClass="tooltip-format" [matTooltipPosition]="tooltipPosition.value">
            </i>
          </mat-label>
          <input matInput required [errorStateMatcher]="matcher" [formControl]="stallGewichtungsfaktorFormControl" />
          <mat-error
            *ngIf="stallGewichtungsfaktorFormControl.invalid">
            {{ formControlGewichtungsfaktorFNumberWarning }}
          </mat-error>
        </mat-form-field>



        <div> <!-- Dummy-Abstandshalter--></div>
        <div> <!-- Dummy-Abstandshalter--></div>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>x-Koordinate in m
            <i class="fas fa-info-circle ktbl-icon-info-select"
              aria-label="Abbildung zum Koordinatensystem anzeigen"
              (mouseenter)="openKoordinatenHilfe($event)"
              (mouseleave)="closeKoordinatenHilfe()">
            </i>
          </mat-label>
          <input matInput required [errorStateMatcher]="matcher" [formControl]="stallXKoordinateFormControl" />
          <mat-error
            *ngIf="stallXKoordinateFormControl.invalid">
            {{ formControlGanzZahlPositivNegativLaeng4NumberWarning }}
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>y-Koordinate in m
            <i class="fas fa-info-circle ktbl-icon-info-select"
              aria-label="Abbildung zum Koordinatensystem anzeigen"
              (mouseenter)="openKoordinatenHilfe($event)"
              (mouseleave)="closeKoordinatenHilfe()">
            </i>
          </mat-label>
          <input matInput required [errorStateMatcher]="matcher" [formControl]="stallYKoordinateFormControl" />
          <mat-error
            *ngIf="stallYKoordinateFormControl.invalid">
            {{ formControlGanzZahlPositivNegativLaeng4NumberWarning }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Quellenspezifischer Zusatzabstand in m
            <i class="fas fa-info-circle ktbl-icon-info-select"
              matTooltip="Abstand zwischen Emissionsschwerpunkt ES der Stallquelle und der am weitesten entfernten äußeren Begrenzung der Austrittsfläche der Emission in die Atmosphäre."
              matTooltipClass="tooltip-format" [matTooltipPosition]="tooltipPosition.value">
            </i>

          </mat-label>
          <input matInput required [errorStateMatcher]="matcher"
            [formControl]="stallQuellenspezZusatzabstandFormControl" />
          <mat-error *ngIf="
              stallQuellenspezZusatzabstandFormControl.invalid
            ">
            {{ formControlGanzZahlLaeng4OderKomma1NumberWarning }}
          </mat-error>
        </mat-form-field>
      </ng-container>
      <!--------------------------------------------------------------------------------------------------->
      <!--------------------------------------------------------------------------------------------------->
      <ng-container *ngIf="quelleFormControl.value === 2">
        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Art der Flächenquelle</mat-label>
          <mat-select required disableRipple [formControl]="flaecheFlaechenquellartFormControl"
            [errorStateMatcher]="matcher" (selectionChange)="onSelectFlaecheFlaechenquelle()"
            panelClass="ktbl-large-select-panel">
            <mat-option *ngFor="let entry of localService.flaechenquellartList.value"
              [value]="entry.idFlaechenquellart">
              {{ entry.flaechenquellart }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="flaecheFlaechenquellartFormControl.invalid">
            Es wird eine Flächenquelle benötigt.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Emissionsminderungsmaßnahme</mat-label>
          <mat-select required disableRipple [formControl]="flaecheMinderungsmassnahmeFormControl"
            [errorStateMatcher]="matcher" (selectionChange)="onSelectFlaecheMinderungsmassnahme()"
            panelClass="ktbl-large-select-panel">
            <mat-option *ngFor="
                  let entry of selectedMinderungsmassnahmeFlaecheList
                " [value]="entry.idMmFlaechenZuord">
              {{ entry.minderungsmassnahmeWirkungsgrad }}
            </mat-option>
          </mat-select>

          <mat-error *ngIf="flaecheMinderungsmassnahmeFormControl.invalid">
            Es wird eine Emissionsminderungsmaßnahme benötigt.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Wirkungsgrad in %
            <i class="fas fa-info-circle ktbl-icon-info-select"
              matTooltip="Entsperrt wenn bei Emissionsminderungsmaßnahme 'Sonstige Maßnahme' ausgewählt ist."
              matTooltipClass="tooltip-format" [matTooltipPosition]="tooltipPosition.value">
            </i>
          </mat-label>
          <input matInput required [errorStateMatcher]="matcher" [formControl]="flaecheWirkungsgradFormControl" />
          <mat-error
            *ngIf="flaecheWirkungsgradFormControl.invalid">
            {{ formControlGanzZahlLaeng2OderKomma1NumberWarning }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Gewichtungsfaktor f

          </mat-label>
          <input matInput required [errorStateMatcher]="matcher" [formControl]="flaecheGewichtungsfaktorFormControl" />
          <mat-error
            *ngIf="flaecheGewichtungsfaktorFormControl.invalid">
            {{ formControlGewichtungsfaktorFNumberWarning}}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Länge/Höhe in m</mat-label>

          <input matInput required [errorStateMatcher]="matcher" [formControl]="flaecheLaengeHoeheFormControl" />
          <mat-error
            *ngIf="flaecheLaengeHoeheFormControl.invalid">
            {{ formControlGanzZahlLaeng2OderKomma1NumberWarning }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Breite in m</mat-label>

          <input matInput required [errorStateMatcher]="matcher" [formControl]="flaecheBreiteFormControl" />
          <mat-error
            *ngIf="flaecheBreiteFormControl.invalid">
            {{ formControlGanzZahlLaeng2OderKomma1NumberWarning }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Durchmesser in m</mat-label>
          <input matInput required [errorStateMatcher]="matcher" [formControl]="flaecheDurchmesserFormControl" />
          <mat-error
            *ngIf="flaecheDurchmesserFormControl.invalid">
            {{ formControlGanzZahlLaeng2OderKomma1NumberWarning }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>x-Koordinate in m
            <i class="fas fa-info-circle ktbl-icon-info-select"
              aria-label="Abbildung zum Koordinatensystem anzeigen"
              (mouseenter)="openKoordinatenHilfe($event)"
              (mouseleave)="closeKoordinatenHilfe()">
            </i>
          </mat-label>
          <input matInput required [errorStateMatcher]="matcher" [formControl]="flaecheXKoordinateFormControl" />
          <mat-error
            *ngIf="flaecheXKoordinateFormControl.invalid">
            {{ formControlGanzZahlPositivNegativLaeng4NumberWarning }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>y-Koordinate in m
            <i class="fas fa-info-circle ktbl-icon-info-select"
              aria-label="Abbildung zum Koordinatensystem anzeigen"
              (mouseenter)="openKoordinatenHilfe($event)"
              (mouseleave)="closeKoordinatenHilfe()">
            </i>
          </mat-label>
          <input matInput required [errorStateMatcher]="matcher" [formControl]="flaecheYKoordinateFormControl" />
          <mat-error
            *ngIf="flaecheYKoordinateFormControl.invalid">
            {{ formControlGanzZahlPositivNegativLaeng4NumberWarning }}
          </mat-error>
        </mat-form-field>

      </ng-container>
      <!--------------------------------------------------------------------------------------------------->
      <!--------------------------------------------------------------------------------------------------->

      <ng-container *ngIf="quelleFormControl.value === 3">
        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Gewichtungsfaktor f</mat-label>
          <input matInput required [errorStateMatcher]="matcher" [formControl]="sonstigeGewichtungsfaktorFormControl" />
          <mat-error
            *ngIf="sonstigeGewichtungsfaktorFormControl.invalid">
            {{ formControlGewichtungsfaktorFNumberWarning }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Emission in GE/s</mat-label>
          <input matInput required [errorStateMatcher]="matcher" [formControl]="sonstigeEmissionFormControl" />
          <mat-error
            *ngIf="sonstigeEmissionFormControl.invalid">
            {{ formControlGanzZahlLaeng4NumberWarning }}
          </mat-error>
        </mat-form-field>

        <div> <!-- Dummy-Abstandshalter--></div>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>x-Koordinate in m
            <i class="fas fa-info-circle ktbl-icon-info-select"
              aria-label="Abbildung zum Koordinatensystem anzeigen"
              (mouseenter)="openKoordinatenHilfe($event)"
              (mouseleave)="closeKoordinatenHilfe()">
            </i>
          </mat-label>
          <input matInput required [errorStateMatcher]="matcher" [formControl]="sonstigeXKoordinateFormControl" />
          <mat-error
            *ngIf="sonstigeXKoordinateFormControl.invalid">
            {{ formControlGanzZahlPositivNegativLaeng4NumberWarning }}
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>y-Koordinate in m
            <i class="fas fa-info-circle ktbl-icon-info-select"
              aria-label="Abbildung zum Koordinatensystem anzeigen"
              (mouseenter)="openKoordinatenHilfe($event)"
              (mouseleave)="closeKoordinatenHilfe()">
            </i>
          </mat-label>
          <input matInput required [errorStateMatcher]="matcher" [formControl]="sonstigeYKoordinateFormControl" />
          <mat-error
            *ngIf="sonstigeYKoordinateFormControl.invalid">
            {{ formControlGanzZahlPositivNegativLaeng4NumberWarning }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="ktbl-input-box">
          <mat-label>Quellenspezifischer Zusatzabstand in m
            <i class="fas fa-info-circle ktbl-icon-info-select"
              matTooltip="Abstand zwischen Emissionsschwerpunkt ES der Stallquelle und der am weitesten entfernten äußeren Begrenzung der Austrittsfläche der Emission in die Atmosphäre."
              matTooltipClass="tooltip-format" [matTooltipPosition]="tooltipPosition.value">
            </i>

          </mat-label>
          <input matInput required [errorStateMatcher]="matcher"
            [formControl]="sonstigeQuellenspezZusatzabstandFormControl" />
          <mat-error *ngIf="
              sonstigeQuellenspezZusatzabstandFormControl.invalid
            ">
            {{ formControlGanzZahlLaeng4OderKomma1NumberWarning }}
          </mat-error>
        </mat-form-field>
      </ng-container>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="ktbl-button-container">
      <div class="ktbl-button-container-left">
        <button class="ktbl-button-sekundaer ktbl-button-width-m" type="button"
          [mat-dialog-close]="0">
          Abbrechen
        </button>
      </div>

      <div class="ktbl-button-container-right">
        <button class="ktbl-button-primaer ktbl-button-width-m" (click)="onClickUebernehmen()" type="button" [disabled]="!isFormValid()"
          [mat-dialog-close]="1">
          Übernehmen
        </button>
      </div>
    </div>

  </mat-dialog-actions>
  <div class="ktbl-spacer-top-bottom"></div>

</div>